<script setup>
import { computed, onMounted, ref } from 'vue'
import { ChartBarSquareIcon, CpuChipIcon } from '@heroicons/vue/24/outline'
import { useI18n } from '../i18n.js'
import { loadPlatformShell, session } from '../session.js'

const { t } = useI18n()
const loading = ref(true)
const error = ref('')
const applications = computed(() => session.applications)
const iconById = { NAFTAPOS: ChartBarSquareIcon, PTS2: CpuChipIcon }

async function load() {
  loading.value = true
  error.value = ''
  try {
    await loadPlatformShell({ force: true })
  } catch (cause) {
    error.value = cause.message
  } finally {
    loading.value = false
  }
}

onMounted(load)
</script>

<template>
  <section class="application-catalog-view">
    <header class="application-catalog-heading">
      <p class="eyebrow">{{ t('nextReportsPlatform') }}</p>
      <h1>{{ t('services') }}</h1>
      <p>{{ t('servicesHint') }}</p>
    </header>
    <p v-if="error" class="notice error" role="alert">{{ error }}</p>
    <div v-if="loading" class="catalog-loading">{{ t('loading') }}</div>
    <div v-else-if="applications.length" class="application-choice-grid" :class="{ single: applications.length === 1 }">
      <RouterLink v-for="application in applications" :key="application.id" class="application-choice"
        :class="`application-${application.id.toLowerCase()}`" :to="application.entryPath">
        <span class="application-choice-icon"><component :is="iconById[application.id]" aria-hidden="true" /></span>
        <span class="application-choice-copy">
          <small>{{ t('service') }}</small>
          <strong>{{ application.displayName }}</strong>
          <b v-if="application.availability === 'PREVIEW'" class="application-preview-badge">{{ t('servicePreview') }}</b>
          <span>{{ application.id === 'NAFTAPOS' ? t('naftaPosServiceHint') : t('pts2ServiceHint') }}</span>
        </span>
        <span class="application-choice-action">{{ t('openService') }} <b aria-hidden="true">→</b></span>
      </RouterLink>
    </div>
    <div v-else class="catalog-empty-state">
      <strong>{{ t('noAvailableServices') }}</strong>
      <p>{{ t('noAvailableServicesHint') }}</p>
    </div>
  </section>
</template>
